import { Spinner, makeStyles, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    gap: '16px',
    backgroundColor: tokens.colorNeutralBackground1,
  },
  message: {
    color: tokens.colorNeutralForeground2,
    fontSize: '14px',
  },
})

interface LoadingProps {
  message?: string
}

export function Loading({ message = 'Loading...' }: LoadingProps) {
  const styles = useStyles()

  return (
    <div className={styles.root}>
      <Spinner size="large" />
      <span className={styles.message}>{message}</span>
    </div>
  )
}
